module.exports = __webpack_public_path__ + "static/media/party.53739df8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/party.svg
// module id = 295
// module chunks = 0